import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

import naturaLatex from "../../../images/remattressorientation/NATURA LATEX.png";

export default function LatexMattressPage() {
  const data = {
    categoryName: "Latex Series",
    description:
      "Eclipse guarantees the use of the best-quality natural latex coming from selected and controlled plantations and tested before transformation in the Eclipse production process. The latex foam conforms to any sleeping position and relaxes the body’s pressure points, guaranteeing its owner a restful sleep.",
    benefits: [
      "Virtually dust mite resistant and posses great anti-microbial properties",
      "Great ventilation property, which makes them one of the best choices for those who suffer from asthma",
      "Ability to conform to your body’s curves, allowing the weight to be evenly distributed",
      "Capability to support any sleeping position, guaranteeing the owner a restful night’s sleep",
      "Free of odors, environmentally safe and breathable",
    ],
    products: [
      {
        img: naturaLatex,
        name: "NATURA LATEX",
        link: "/latex-mattress/natura-latex/",
        startingAt: "₹23,399",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/portofino-Latex.png",
        name: "PORTOFINO LATEX",
        link: "/latex-mattress/portofino-latex/",
        startingAt: "₹19,399",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton-Latex.png",
        name: "PRINCETON LATEX",
        link: "/latex-mattress/princeton-latex/",
        startingAt: "₹18,199",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-Latex.png",
        name: "ORTHO LATEX",
        link: "/latex-mattress/ortho-latex/",
        startingAt: "₹17,099",
      },
    ],
    brochureLink: "https://eclipsemattress.in/assets/pdfs/Eclipse-Catalog.pdf",
    actionToAccess: false,
    // pattern,
    banner: "https://eclipsemattress.in/assets/images/banners/latex-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/latex-m.jpg",
  };
  return (
    <div>
      <SEO
        title="Latex Mattress | Mattress For Back Pain | Eclipse International"
        description="Buy best quality natural latex mattress for back pain with upto 10 years warranty in 6 relaxing body's pressure points and guaranteeing a restful sleep."
        img="https://eclipsemattress.in/assets/linkpreviews/category/latex-mattress.jpg"
      />
      <ProductCategory category={data} />
    </div>
  );
}
